import axios from "axios";

export default function RolesListService() {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/roles",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
